import { IComponentOptions } from 'angular';
import { CreditGapsWizardSubjectTableCtrl } from './credit-gaps-wizard-subject-table.controller';

export const CreditGapsWizardSubjectTableComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentFilter: '<',
  },
  controller: CreditGapsWizardSubjectTableCtrl,
  template: require('./credit-gaps-wizard-subject-table.html'),
};
